"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = _interopRequireDefault(require("../styles"));
var _EDSContext = require("../EDSContext/EDSContext");
var _tokens = require("../styles/tokens");
var _excluded = ["classes", "className", "children", "edsContext"];
var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      width: 'auto',
      backgroundColor: theme.palette.grey[100],
      padding: _tokens.spacing30,
      boxShadow: '0px 0px 0.438rem 0.125rem rgba(0,0,0,0.12)',
      borderBottomLeftRadius: _tokens.borderRadiusMedium,
      borderBottomRightRadius: _tokens.borderRadiusMedium,
      flexWrap: 'wrap'
    }
  };
};

/**
 * A wrapper component to handle the footer of the WeekView component.
 * @done false
 * @updated false
 * @versionAdded v0.2.1
 * @lab true
 */
var CalendarLegend = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var classes = props.classes,
    className = props.className,
    children = props.children,
    edsContext = props.edsContext,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    dir: edsContext.dir,
    className: (0, _classnames.default)(classes.root, className)
  }, rest, {
    ref: ref
  }), children);
});
CalendarLegend.propTypes = {
  /**
   * @ignore
   */
  edsContext: _propTypes.default.object,
  /**
   * @ignore
   */
  classes: _propTypes.default.object,
  /**
   * Custom class name to the outer CalendarLegend component.
   */
  className: _propTypes.default.string,
  /**
   * The children to render within the CalendarLegend.
   * Common children are the CalendarLegendItem, Button, and IconButton.
   */
  children: _propTypes.default.any
};
CalendarLegend.displayName = 'CalendarLegend';
var _default = exports.default = (0, _EDSContext.withEDSContext)((0, _styles.default)(styles)(CalendarLegend));